<template>
  <div>
    <v-radio-group>
      <v-container fluid>
        <v-row justify="center">
          <v-col align="center">
            <span v-if="invoices.length!==0 && originalInvoice.receiverCif===$user.cif"> {{ $t('Candidate invoice for the Forwhjuiojiard:') }} </span>
            <span v-else-if="invoices.length!==0 && originalInvoice.payerCif===$user.cif"> {{ $t('Candidate invoice for the Byppaghfghfgy:') }} </span>
            <span v-else> {{ $t('You not have Candidates!') }} </span>
            <v-simple-table v-if="invoices.length!==0" style="margin-top: 20px; width: 100%">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t('Participant') }}
                    </th>
                    <th class="text-left">
                      {{ $t('Amount') }}
                    </th>
                    <th class="text-left" />
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in invoices" :key="item.invoice._id">
                    <td>{{ getNameFromUser(item.invoice) }}</td>
                    <td>{{ item.invoice.outstandingAmmount }} €</td>
                    <td><v-radio @change="changeInvoice(item)" /></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-btn v-else x-large style="margin-top: 20px" color="primary" @click="goUploadInvoice">
              {{ $t('Upload Candidate') }}
            </v-btn>
            <InvoiceItem v-if="selected" :invoice="originalInvoice" @invoiveMissingInformation="invoiveMissingInformation" />
          </v-col>
        </v-row>
      </v-container>
      <v-dialog v-if="invoiceInoMiss" v-model="visibleInoMiss" width="450">
        <v-card>
          <v-card-title color="primary" class="headline lighten-2" primary-title style="word-break: break-word;">
            <b v-if="isClient(invoiceInoMiss)">{{ $t("Please complete your client invoice datuiuiuiuia:") }}</b>
            <b v-else>{{ $t("Please complete your provider invoice datauuiuuiyuyu:") }}</b>
          </v-card-title>
          <v-card-subtitle style="margin-top: 10px">
            <InvoiceImage v-if="file" :image="file.originalName" :height="'unset'" :width="'100%'" />
          </v-card-subtitle>
          <v-card-text style="text-align: justify;">
            <v-form
              ref="form"
              v-model="valid"
              style=""
            >
              <v-text-field
                ref="formEmail"
                v-model="invoiceInoMiss.number"
                :rules="rules.value"
                :label="$t('Invoice Number')"
                name="email"
                type="text"
                prepend-icon="mdi-mail"
              />
              <v-text-field
                ref="formEmail"
                v-model="invoiceInoMiss.payerCif"
                :label="$t('Payer CIF:')"
                :disabled="disabledPayer"
                :rules="rules.cif"
                name="email"
                type="text"
                prepend-icon="mdi-mail"
                @change="searchEmail(invoiceInoMiss.payerCif, 'pay')"
              />
              <v-text-field
                v-if="showPayerEmail"
                ref="formEmail"
                v-model="payerEmail"
                :label="$t('Payer email:')"
                :rules="rules.email"
                name="email"
                type="text"
                prepend-icon="mdi-mail"
              />
              <v-text-field
                ref="formEmail"
                v-model="invoiceInoMiss.receiverCif"
                :label="$t('Receiver CIF:')"
                :disabled="disabledReceiver"
                :rules="rules.cif"
                name="email"
                type="text"
                prepend-icon="mdi-mail"
                @change="searchEmail(invoiceInoMiss.receiverCif,'rec')"
              />
              <v-text-field
                v-if="showReceiverEmail"
                ref="formEmail"
                v-model="receiverEmail"
                :label="$t('ListInvoices.Receiver email:')"
                :rules="rules.email"
                name="email"
                type="text"
                prepend-icon="mdi-mail"
              />
              <v-text-field
                ref="formEmail"
                v-model="invoiceInoMiss.amount"
                :label="$t('Amount:')"
                :disabled="disabledAmount"
                :rules="rules.number"
                name="email"
                type="text"
                prepend-icon="mdi-mail"
              />
              <v-text-field
                v-if="!missInvoiceBypay"
                ref="formEmail"
                v-model="invoiceInoMiss.accountNumber"
                :rules="rules.iban"
                :label="$t('Account number')"
                name="account"
                type="text"
                prepend-icon="mdi-mail"
              />
            </v-form>
          </v-card-text>

          <v-divider />

          <v-card-actions style="margin-top: 20px">
            <v-col>
              <v-row justify="center">
                <v-btn x-large :disabled="!valid" style="padding: 15px 75px; bottom: 25px" class="justify-center" color="primary" @click="saveInvoice">
                  {{ $t('Save') }}
                </v-btn>
              </v-row>
              <v-row justify="center">
                <v-btn x-large style="padding: 15px 75px; bottom: 25px; margin-top: 10px" class="justify-center" color="secondary" @click="reject">
                  {{ $t('Cancel') }}
                </v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="visibleUserMailMiss" width="450">
        <v-card>
          <v-card-title color="primary" class="headline lighten-2" primary-title style="word-break: break-word;">
            {{ $t("Please complete the other companies information:") }}
          </v-card-title>
          <v-card-text v-if="userACifText !== ''" style="text-align: justify;">
            <h2>{{ $t('Client') }}</h2>
            <v-text-field
              ref="userCifText"
              v-model="userACifText"
              :label="$t('CIF:')"
              :disabled="true"
              name="email"
              type="text"
              prepend-icon="mdi-mail"
            />
            <v-text-field
              ref="userEmailText"
              v-model="userAEmailText"
              :label="$t('Email:')"
              :rules="rules.email"
              name="email"
              type="text"
              prepend-icon="mdi-mail"
            />
          </v-card-text>

          <v-divider />

          <v-card-text v-if="userBCifText !== ''" style="text-align: justify;">
            <h2>{{ $t('ListInvoices.Provider') }}</h2>
            <v-text-field
              ref="userCifText"
              v-model="userBCifText"
              :label="$t('CIF:')"
              :disabled="true"
              name="email"
              type="text"
              prepend-icon="mdi-mail"
            />
            <v-text-field
              ref="userEmailText"
              v-model="userBEmailText"
              :label="$t('Email:')"
              :rules="rules.email"
              name="email"
              type="text"
              prepend-icon="mdi-mail"
            />
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn color="success" @click="saveAllUsers">
              {{ $t('Save') }}
            </v-btn>
            <v-btn color="error" @click="backUsers">
              {{ $t('Cancel') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-radio-group>
  </div>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import InvoiceItem from "../components/InvoiceItem";
import Constants from "../../constants";
import {User} from "../models/user";
import InvoiceImage from "../components/invoice/InvoiceImage";

export default {
    name: "ListInvoices",
    components: {InvoiceItem, InvoiceImage },
    props: {
        sent: {
            type: Boolean,
            default: true
        },
        originalInvoice: {
            type: Object,
            default: null
        },
        byppay: {
            type: Number,
            default: Constants.FORWARD_IDENTIFIER
        }
    },
    data () {
        return {
            invoices: null,
            showPayerEmail: false,
            file: null,
            valid: false,
            receiverEmail: null,
            showReceiverEmail: false,
            visibleInoMiss: false,
            payerEmail: null,
            selected: false,
            visibleUserMailMiss: false,
            invoiceInoMiss: null,
            actInvoice: null,
            disabledNumber: false,
            disabledPayer: false,
            disabledReceiver: false,
            disabledAmount: false,
            userACifText: '',
            userAEmailText: '',
            userBCifText: '',
            userBEmailText: '',
            userAMissingEmail: null,
            userBMissingEmail: null,
            missInvoiceBypay: false,
            checkboxes: [],
            rules: {
                cif: [
                    val => (val || '').length > 0 || this.$t('Error.This field is required'),
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)'),
                    v => this.invoiceInoMiss.receiverCif.toUpperCase() !== this.invoiceInoMiss.payerCif.toUpperCase() || this.$t('Error.The CIF must be different than yours.'),
                ],
                value: [v => !!v || this.$t('The value field is required'), ],
                number: [
                    v => !!v || this.$t('Error.This field is required'),
                    v => !isNaN(v) || this.$t('Have to be a number'), ],
                comission: [v => (!isNaN(parseFloat(v)) && v >= 0) || this.$t('Comission must be greater than 0')],
                email: [
                    v => !!v || this.$t('Error.The mail field is required'),
                    v => /.+@.+\..+/.test(v) || this.$t('The mail must be valid.')],
                iban: [
                    v => !!v || this.$t('The account number field is required'),
                    v => /([A-Z]{2})\s*\t*(\d\d)\s*\t*(\d\d\d\d)\s*\t*(\d\d\d\d)\s*\t*(\d\d)\s*\t*(\d\d\d\d\d\d\d\d\d\d)/.test(v) || this.$t('The account number (IBAN) is invalid!')
                ],
            },
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            this.invoices = [];
            this.visibleInoMiss = false;
            this.visibleUserMailMiss = false;
            this.invoiceInoMiss = null;
            this.disabledNumber = false;
            this.disabledPayer = false;
            this.disabledReceiver = false;
            this.disabledAmount = false;
            this.userACifText = '';
            this.userAEmailText = '';
            this.userBCifText = '';
            this.userBEmailText = '';
            this.userAMissingEmail = null;
            this.userBMissingEmail = null;
            ApiRepository.listInvoices(this.sent, !this.sent, false)
                .then((res) => {
                    this.invoices = res.data.invoices;
                    this.checkboxes = Array(this.invoices.length).fill(false);
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error.Error accepting petition'), color: 'error'});
                    console.error(err);
                });
        },
        isClient (invoice) {
            return invoice.receiverCif === this.$user.cif || invoice.payerCif !== this.$user.cif;
        },
        invoiveMissingInformation (event) {
            if (!this.actInvoice.amount || !this.actInvoice.payerCif || !this.actInvoice.receiverCif  || !this.actInvoice.amount  || (!this.actInvoice.accountNumber && !event.bypay) || !this.actInvoice.payer || !this.actInvoice.payer.email || !this.actInvoice.receiver || !this.actInvoice.receiver.email || !this.actInvoice.number) {
                this.disabledNumber = !!this.actInvoice.number;
                this.disabledPayer = !!this.actInvoice.payerCif;
                this.disabledReceiver = !!this.actInvoice.receiverCif;
                this.disabledAmount = !!this.actInvoice.amount;
                this.showPayerEmail = (!this.actInvoice.payer || !this.actInvoice.payer.email);
                this.showReceiverEmail = (!this.actInvoice.receiver || !this.actInvoice.receiver.email);
                this.missInvoiceBypay = !!event.bypay;

                this.invoiceInoMiss = this.actInvoice;

                if (!this.disabledPayer) {
                    this.invoiceInoMiss.payerCif = "";
                }
                if (!this.disabledReceiver) {
                    this.invoiceInoMiss.receiverCif = "";
                }

                if (this.actInvoice.rossumStatus === Constants.ROSSUM.STATUS_SCANNED &&  this.actInvoice.rossumCollectedInfo) {
                    let detectedFields = this.$t('Rossum have detected the next information:');
                    let openModal = false;
                    if (this.actInvoice.rossumCollectedInfo.payerCif && !this.disabledPayer) {
                        detectedFields += "<br>";
                        detectedFields += "<b>" + this.$t('Payer cif: ') + "</b>" + this.invoice.rossumCollectedInfo.payerCif;
                        openModal = true;
                    }
                    if (this.actInvoice.rossumCollectedInfo.receiverCif && !this.disabledReceiver) {
                        detectedFields += "<br>";
                        detectedFields += "<b>" + this.$t('Receiver cif: ') + "</b>" + this.actInvoice.rossumCollectedInfo.receiverCif;
                        openModal = true;
                    }
                    if (this.actInvoice.rossumCollectedInfo.amount && !this.disabledAmount) {
                        detectedFields += "<br>";
                        detectedFields += "<b>" + this.$t('Amount: ') + "</b>" + this.actInvoice.rossumCollectedInfo.amount;
                        openModal = true;
                    }
                    if (this.actInvoice.rossumCollectedInfo.number && !this.disabledNumber) {
                        detectedFields += "<br>";
                        detectedFields += "<b>" + this.$t('Number: ') + "</b>" + this.actInvoice.rossumCollectedInfo.number;
                        openModal = true;
                    }
                    if (this.actInvoice.rossumCollectedInfo.accountNumber && !this.missInvoiceBypay) {
                        detectedFields += "<br>";
                        detectedFields += "<b>" + this.$t('Account number: ') + "</b>" + this.actInvoice.rossumCollectedInfo.accountNumber;
                        openModal = true;
                    }
                    detectedFields += "<br>";
                    detectedFields += this.$t('Do you want to import?(in the next screen you can modify the fields)');
                    if (openModal) {
                        this.$root.$emit('show-confirmation-modal', {
                            title: this.$t('Import information?'),
                            message: detectedFields,
                            oneButton: false,
                            yes: () => {
                                if (this.actInvoice.rossumCollectedInfo.payerCif && !this.disabledPayer) {
                                    this.invoiceInoMiss.payerCif = this.actInvoice.rossumCollectedInfo.payerCif;
                                    this.searchEmail(this.invoiceInoMiss.payerCif, 'pay');
                                }
                                if (this.actInvoice.rossumCollectedInfo.receiverCif && !this.disabledReceiver) {
                                    this.invoiceInoMiss.receiverCif = this.actInvoice.rossumCollectedInfo.receiverCif;
                                    this.searchEmail(this.invoiceInoMiss.receiverCif, 'rec');
                                }
                                if (this.actInvoice.rossumCollectedInfo.amount && !this.disabledAmount) {
                                    this.invoiceInoMiss.amount = this.actInvoice.rossumCollectedInfo.amount;
                                }
                                if (this.actInvoice.rossumCollectedInfo.number && !this.disabledNumber) {
                                    this.invoiceInoMiss.number = this.actInvoice.rossumCollectedInfo.number;
                                }
                                if (this.actInvoice.rossumCollectedInfo.accountNumber && !this.missInvoiceBypay) {
                                    this.invoiceInoMiss.accountNumber = this.actInvoice.rossumCollectedInfo.accountNumber;
                                }

                                this.visibleInoMiss = true;
                            },
                            no: () => {
                                this.visibleInoMiss = true;
                            }
                        });
                    } else {
                        this.visibleInoMiss = true;
                    }
                } else {
                    this.visibleInoMiss = true;
                }
            } else {
                this.createFactoring(this.actInvoice);
            }
        },
        searchEmail (cif, who) {
            ApiRepository.getUserByCif(cif)
                .then((res) => {
                    who === "pay" ? this.payerEmail = res.data.email : this.receiverEmail = res.data.email;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        saveInvoice () {
            ApiRepository.updateInvoiceList(this.invoiceInoMiss._id, this.invoiceInoMiss.number, this.invoiceInoMiss.amount, this.invoiceInoMiss.receiverCif, this.invoiceInoMiss.payerCif, this.invoiceInoMiss.accountNumber, this.invoiceInoMiss.payerEmail, this.invoiceInoMiss.receiverEmail)
                .then(() => {
                    this.visibleInoMiss = false;
                    ApiRepository.getInvoiceById(this.invoiceInoMiss._id)
                        .then((res) => {
                            if (res.data.invoice) {
                                if (!res.data.invoice.payer.email) {
                                    ApiRepository.updateEmailUser(res.data.invoice.payer._id, this.payerEmail)
                                        .then(() => {
                                            this.createFactoring(res.data.invoice);
                                        })
                                        .catch((err) => {
                                            console.log(err);
                                            let message = this.$t('ERROR: Something went wrong');
                                            if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_MAIL) {
                                                message = this.$t('Already exists a user with this Email');
                                            }
                                            this.$root.$emit('show-snackbar', {
                                                message: message,
                                                color: 'error'
                                            });
                                        });
                                } else if (!res.data.invoice.receiver.email) {
                                    ApiRepository.updateEmailUser(res.data.invoice.receiver._id, this.receiverEmail)
                                        .then(() => {
                                            this.createFactoring(res.data.invoice);
                                        })
                                        .catch((err) => {
                                            console.log(err);
                                            let message = this.$t('ERROR: Something went wrong');
                                            if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_MAIL) {
                                                message = this.$t('Already exists a user with this Email');
                                            }
                                            this.$root.$emit('show-snackbar', {
                                                message: message,
                                                color: 'error'
                                            });
                                        });
                                } else {
                                    this.createFactoring(res.data.invoice);
                                }
                            }
                        }).finally(() => {
                            this.loading = false;
                        });
                })
                .catch((err) => {
                    console.log(err);
                    this.visibleInoMiss = false;
                    this.$root.$emit('show-snackbar', {
                        message: this.$t('ERROR: Something went wrong'),
                        color: 'error'
                    });
                    this.$emit('error');
                    console.error(err);
                });
            //}
        },
        checkUserEmailAndGenerate (invoice) {
            this.invoiceInoMiss = invoice;
            let idFirstuser = "";
            if (typeof invoice.payer.email === "undefined") {
                this.userAMissingEmail = invoice.payer;
                this.userACifText = invoice.payer.cif;
                idFirstuser = invoice.payer._id.toString();
                this.visibleUserMailMiss = true;
            } else if (typeof invoice.receiver !== "undefined" && typeof invoice.receiver.email === "undefined") {
                this.userAMissingEmail = invoice.receiver;
                this.userACifText = invoice.receiver.cif;
                idFirstuser = invoice.receiver._id.toString();
                this.visibleUserMailMiss = true;
            } else {
                this.userAMissingEmail = null;
            }
            if (typeof this.originalInvoice.payer.email === "undefined") {
                this.userBMissingEmail = this.originalInvoice.payer;
                if (idFirstuser !== this.originalInvoice.payer._id.toString()) {
                    this.userBCifText = this.originalInvoice.payer.cif;
                    this.visibleUserMailMiss = true;
                }
            } else if (typeof this.originalInvoice.receiver.email === "undefined") {
                this.userBMissingEmail = this.originalInvoice.receiver;
                if (idFirstuser !== this.originalInvoice.receiver._id.toString()) {
                    this.userBCifText = this.originalInvoice.receiver.cif;
                    this.visibleUserMailMiss = true;
                }
            }
            if (!this.visibleUserMailMiss) {
                this.createFactoring(invoice);
            }
        },
        saveAllUsers () {
            if (this.userAMissingEmail != null && !this.userAMissingEmail.email) {
                this.saveUseremail(this.userAMissingEmail, this.userAEmailText);
            } else if (this.userBMissingEmail != null && !this.userBMissingEmail.email) {
                this.saveUseremail(this.userBMissingEmail, this.userBEmailText);
            } else {
                this.checkUserEmailAndGenerate(this.invoiceInoMiss);
            }
            this.fetch();
        },
        backUsers () {
            this.fetch();
            this.visibleUserMailMiss = false;
        },
        saveUseremail (userMissing, newEmail) {
            ApiRepository.saveUser(userMissing.cif, userMissing.name, userMissing.surname, userMissing.phone, newEmail, userMissing.address, userMissing.country, userMissing.role, userMissing._id, null, null, null)
                .then(() => {
                    this.visibleUserMailMiss = false;
                    userMissing.email = newEmail;
                    if (this.userAMissingEmail && this.userBMissingEmail && this.userAMissingEmail._id.toString() === this.userBMissingEmail._id.toString()) {
                        this.userAMissingEmail.email = newEmail;
                        this.userBMissingEmail.email = newEmail;
                    }
                    this.saveAllUsers();
                })
                .catch((err) => {
                    let miss = "";
                    console.log(err);
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_CIF) {
                        miss = this.$t('Already exists a user with this CIF');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_MAIL) {
                        miss = this.$t('Already exists a user with this Email');
                    } else {
                        miss = this.$t('Error.Something went wrong');
                    }
                    this.$root.$emit('show-snackbar', {message: miss, color: 'error'});
                    this.$emit('error');
                    console.error(err);
                    this.visibleUserMailMiss = false;
                    this.fetch();
                });
        },
        createFinalFactoring (invoice) {
            this.$root.$emit('start-loading');

            let data = null, factoring = null;
            const invoiceAB = this.byppay === Constants.FORWARD_IDENTIFIER ? this.originalInvoice : invoice;
            const invoiceBC = this.byppay === Constants.FORWARD_IDENTIFIER ? invoice : this.originalInvoice;
            let video = null;
            if (invoice.fileVideo) video = invoice.fileVideo.name;
            ApiRepository.createBypay(invoiceAB, invoiceBC, false, video ).then((res) => {
                factoring = res.data.factoring;
                data = res.data.result;

                if (invoice.fileVideo) {
                    //ApiRepository.saveVideo s'ha de passar video també
                    const extension = invoice.fileVideo.name.split('.').pop().toLowerCase();
                    const file = new File([invoice.fileVideo], factoring + "." + extension, {type: invoice.fileVideo.type, lastModified: new Date()});
                    ApiRepository.saveVideo(file)
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                            this.$root.$emit('show-snackbar', {message: this.$t('Error saving video'), color: "error"});
                        });
                }

                this.$root.$emit('show-notification-modal', {
                    title: this.$t('Notification options'),
                    message: this.$t('How do you want to notify compensation?'),
                    factoring: factoring,
                    data: data,
                    yes: () => {},
                    no: () => {},
                });

            //this.$root.$emit('show-snackbar', {message: this.$t('Saved successfully!'), color: 'success'});
            }).catch(err => {
                console.log(err);
                this.$root.$emit('show-snackbar', {message: this.$t('Error.Something went wrong'), color: 'error'});
            }).finally(() => {
                this.$root.$emit('stop-loading');
            });
        },      
        createFactoring (invoice) {
            this.$root.$emit('show-video-modal', {
                save: (fileVideo) => {
                    invoice.fileVideo = fileVideo;
                    //this.$root.$emit('createFactoring', {invoice: invoice});
                    this.createFinalFactoring(invoice);
                },
                skip: () => {
                    //this.$root.$emit('createFactoring', {invoice: invoice});
                    this.createFinalFactoring(invoice);
                },
                back: () => {
                    this.$root.$emit('close-video-modal', {});
                    this.selected = false;
                    this.actInvoice = null;
                    this.fetch();
                }
            });
        },
        reject () {
            if (!this.disabledNumber) {
                this.invoiceInoMiss.number = null;
            }
            if (!this.disabledPayer) {
                this.invoiceInoMiss.payerCif = null;
            }
            if (!this.disabledReceiver) {
                this.invoiceInoMiss.receiverCif = null;
            }
            if (!this.disabledAmount) {
                this.invoiceInoMiss.amount = null;
            }
            if (this.showPayerEmail) {
                this.payerEmail = "";
            }
            if (this.showReceiverEmail) {
                this.receiverEmail = "";
            }
            if (!this.missInvoiceBypay) {
                this.invoiceInoMiss.accountNumber = null;
            }
            this.visibleInoMiss = false;
        },
        changeInvoice (item) {
            if (!this.actInvoice) {
                this.actInvoice = item.invoice;
                this.file = item.file;
                this.selected = true;
            } else if (this.actInvoice._id === item.invoice._id) {
                this.selected = false;
                this.file = null;
                this.actInvoice = null;
                this.file = null;
            } else {
                this.actInvoice = item.invoice;
                this.file = item.file;
                this.selected = true;
            }
        },
        getNameFromUser (item) {
            let user;
            if (this.$user) item.payerCif !== this.$user.cif ? user = item.payer : user = item.receiver;
            if ( user ) {
                const userModel = new User(user);
                return userModel.getName();
            } else {
                return "Unknown";
            }
        },
        goUploadInvoice () {
            this.$router.push({name: 'imageInvoice', params: {byppay: this.byppay, id: this.originalInvoice._id}, replace: true});
        }
    }
};
</script>

<style scoped>

</style>
